import {AdmissionWrapper} from './styles'

export const Admission = () => {
    return (
        <AdmissionWrapper>
            <iframe src="https://www.youtube.com/embed/JzXMfw3KPUI?si=Y_i5civN9dYAEeOK" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </AdmissionWrapper>
    )
}